import { Segment3D } from '@paragon/three-shared';

/**
 * Returns a segment with the same magnitude and direction, but ending where the input segment started.
 */
export const reverseShiftSegment = (segment: Segment3D): Segment3D => ({
  end: segment.start,
  start: {
    x: segment.start.x - (segment.end.x - segment.start.x),
    y: segment.start.y - (segment.end.y - segment.start.y),
    z: segment.start.z - (segment.end.z - segment.start.z),
  },
});
